import type {CreateAutomationFormValues} from "./schema";

type TimingFields = Pick<
  CreateAutomationFormValues,
  "sendTiming" | "delayValue" | "delayUnit"
>;

function unitLabel(n: number, unit: string): string {
  if (unit === "minutes") return n === 1 ? "minute" : "minutes";
  if (unit === "hours") return n === 1 ? "hour" : "hours";
  if (unit === "days") return n === 1 ? "day" : "days";
  return unit;
}

/** Human-readable delay line for offering form tags (matches Figma-style copy). */
export function formatAutomationTimingLabel(
  v: TimingFields,
  context: "purchase" | "abandonment"
): string {
  if (context === "abandonment") {
    return "30 minutes after abandonment";
  }
  const tail = "after purchase";
  if (v.sendTiming === "immediately") {
    return `Immediately ${tail}`;
  }
  const n = Number(v.delayValue) || 0;
  if (n === 0) {
    return `Immediately ${tail}`;
  }
  const u = unitLabel(n, String(v.delayUnit ?? "minutes"));
  return `${n} ${u} ${tail}`;
}
